/**
 * WARNING!
 * ----------------------------------------------------------------------------
 * WE ARE NOT FOLLOWING SEGMENT DATA COLLECTION BEST PRACTICES:
 * https://segment.com/docs/protocols/tracking-plan/best-practices/
 * ----------------------------------------------------------------------------
 * THIS SHOULD BE AUDITED AND APPROPRIATELY DEPRECATED
 * FOR NOW PLEASE ONLY USE THE @EVENTS AT THE BOTTOM OF THIS FILE
 * ----------------------------------------------------------------------------
 */
export const NAVIGATION_EVENTS = {
  PRIMARY: {
    USER_CLICKED_PRIMARY_NAV_PRICING: 'USER_CLICKED_PRIMARY_NAV_PRICING',
    GET_API_KEYS_BUTTON: 'HOMEPAGE_MAIN_NAV_GET_API_KEYS_BUTTON',
  },
  FOOTER: {
    USER_CLICKED_FOOTER_NAV_PRICING: 'USER_CLICKED_FOOTER_NAV_PRICING',
    GET_STARTED_BUTTON: 'FOOTER_GET_STARTED_BUTTON',
    CONTACT_SALES_BUTTON: 'FOOTER_CONTACT_SALES_BUTTON',
  },
};

export const HOMEPAGE_EVENTS = {
  GET_API_KEYS: {
    HERO: 'HOMEPAGE_HERO_GET_API_KEYS_BUTTON',
    FOOTER: 'HOMEPAGE_FOOTER_GET_API_KEYS_BUTTON',
  },
  CONTACT_SALES: {
    HERO: 'HOMEPAGE_HERO_CONTACT_SALES_LINK',
    FOOTER: 'HOMEPAGE_FOOTER_CONTACT_SALES_BUTTON',
  },
};

export const PRICING_EVENTS = {
  PRICING_GET_API_KEYS_BUTTON_CLICK: 'PRICING_GET_API_KEYS_BUTTON_CLICK',
  PRICING_REQUEST_ACCESS_BUTTON_CLICK: 'PRICING_REQUEST_ACCESS_BUTTON_CLICK',
  PRICING_CONTACT_SALES_BUTTON_CLICK: 'PRICING_CONTACT_SALES_BUTTON_CLICK',
  PRICING_ESUSU_CASE_STUDY_LINK: 'PRICING_ESUSU_CASE_STUDY_LINK',
  PRICING_SHIFT_CASE_STUDY_LINK: 'PRICING_SHIFT_CASE_STUDY_LINK',
  PRICING_ZETA_CASE_STUDY_LINK: 'PRICING_ZETA_CASE_STUDY_LINK',
  PRICING_FAQ_CONTACT_SALES_LINK: 'PRICING_FAQ_CONTACT_SALES_LINK',
  PRICING_FAQ_PLAID_BILLING_LINK: 'PRICING_FAQ_PLAID_BILLING_LINK',
};

export const PARTNERSHIP_DIRECTORY_EVENTS = {
  PARTNER_CLICK: 'PARTNER_CLICK',
  INDUSTRY_SEARCH: 'INDUSTRY_SEARCH',
};

export const EMBEDDED_VIDEO_EVENTS = {
  ON_PLAY: 'ON_PLAY',
  ON_PAUSE: 'ON_PAUSE',
  ON_SEEK: 'ON_SEEK',
  ON_ENDED: 'ON_ENDED',
  ON_ERROR: 'ON_ERROR',
};

export const TUTORIAL_EVENTS = {
  TUTORIAL_PROJECT_RESET: 'TUTORIAL_PROJECT_RESET',
  TUTORIAL_STEP_VIEWED: 'TUTORIAL_STEP_VIEWED',
  TUTORIAL_STARTED: 'TUTORIAL_STARTED',
  TUTORIAL_PROJECT_SAVED: 'TUTORIAL_PROJECT_SAVED',
  TUTORIAL_FEEDBACK: 'TUTORIAL_FEEDBACK',
};

export const DEMO_EVENTS = {
  LINK_START: 'DEMO_LINK_START',
  LINK_SUCCESS: 'DEMO_LINK_SUCCESS',
  LINK_EXIT: 'DEMO_LINK_EXIT',
  LAUNCH_EXTERNAL: 'DEMO_LAUNCH_EXTERNAL',
};

export const CHATBOT_EVENTS = {
  CHAT_SEARCH_TAB_SELECTED: 'CHAT_SEARCH_TAB_SELECTED',
  QUESTION_ASKED: 'CHATBOT_QUESTION_ASKED',
  FEEDBACK_GIVEN: 'CHATBOT_FEEDBACK_GIVEN',
  FIRST_RESPONSE_RECEIVED: 'CHATBOT_FIRST_RESPONSE_RECEIVED',
  SOURCES_RECEIVED: 'CHATBOT_SOURCES_RECEIVED',
  QUESTION_FINISHED: 'CHATBOT_QUESTION_FINISHED',
  USER_CLICKED_STOP: 'CHATBOT_USER_CLICKED_STOP',
  ERROR_RECEIVED: 'CHATBOT_ERROR_RECEIVED',
  COPY_ANSWER: 'CHATBOT_COPY_ANSWER',
  COPY_LINK: 'CHATBOT_COPY_LINK',
  CONVERSATION_LOADED: 'CHATBOT_CONVERSATION_LOADED',
};

export const LINK_TOKEN_CREATE_EVENTS = {
  SELECTOR_LOADED: 'LINK_TOKEN_CREATE_SELECTOR_LOADED',
  OPTION_PICKED: 'LINK_TOKEN_CREATE_OPTION_PICKED',
};

export const MARKDOWN_BUTTON_TRACKING_IDS = {
  BUTTON_OPENED: 'MARKDOWN_BUTTON_OPENED',
  BUTTON_COPIED: 'MARKDOWN_BUTTON_COPIED',
  BUTTON_VIEWED_IN_NEW_PAGE: 'MARKDOWN_BUTTON_VIEWED_IN_NEW_PAGE',
  BUTTON_COPY_FAILED: 'MARKDOWN_BUTTON_COPY_FAILED',
  ICON_BUTTON_OPENED: 'MARKDOWN_ICON_BUTTON_OPENED',
  ICON_BUTTON_COPIED: 'MARKDOWN_ICON_BUTTON_COPIED',
  ICON_BUTTON_VIEWED_IN_NEW_PAGE: 'MARKDOWN_ICON_BUTTON_VIEWED_IN_NEW_PAGE',
  ICON_BUTTON_COPY_FAILED: 'MARKDOWN_ICON_BUTTON_COPY_FAILED',
};

export const PAGE = {
  LANDING_PAGE: 'LANDING_PAGE',
  CAREERS: 'CAREERS',
  EVENT: 'EVENT',
  INSTITUTION: 'INSTITUTION',
  PARTNER: 'PARTNER',
  PRODUCT: 'PRODUCT',
  USE_CASE: 'USE_CASE',
  ARTICLE: 'ARTICLE',
  BLOG: 'BLOG',
  THREADS_EVENT_23: 'THREADS_EVENT_23',
};

export const LOGGED_IN_DOCS = {
  USER_CLICKED_LOGGED_IN_DOCS_SIGN_IN: 'USER_CLICKED_LOGGED_IN_DOCS_SIGN_IN',
  USER_CHANGED_SETTINGS: 'USER_CHANGED_SETTINGS',
  USER_CLICKED_ON_MENU: 'USER_CLICKED_ON_MENU',
};

export const LINKEDIN_CAPI_EVENTS = {
  PAGE_VIEW: 'LI-CAPI-Page-View',
  FORM_SUBMIT: 'LI-CAPI-Form-Submit',
  SIGNUP_REQUEST_SUCCESS: 'LI-CAPI-Signup-Request-Success',
};

export const PERFORMANCE_EVENTS = {
  IS_LOW_PERFORMANCE: 'IS_LOW_PERFORMANCE',
  IS_NOT_LOW_PERFORMANCE: 'IS_NOT_LOW_PERFORMANCE',
};

export const ERROR_EVENTS = {
  ERROR_500: 'ERROR_500',
};

export const BOT_EVENTS = {
  SUSPECTED_BOT_SESSION: 'SUSPECTED_BOT_SESSION',
};

export const Events = {
  BUTTON_CLICKED: 'BUTTON_CLICKED',
  CHANGED: 'CHANGED',
  ERRORED: 'ERRORED',
  EXPERIMENT_EXCLUDED: 'EXPERIMENT_EXCLUDED', // Visitor had an experiment arm but failed the eligibility rules
  FOCUSED: 'FOCUSED',
  FORM_STARTED: 'FORM_STARTED', // User has begun interacting the form, like filling a form field
  FORM_STEP_COMPLETED: 'FORM_STEP_COMPLETED', // Visitor passed one step of a multi-step form
  FORM_SUBMIT_ERROR: 'FORM_SUBMIT_ERROR', // Form submission failed
  FORM_SUBMIT_SUCCESS: 'FORM_SUBMIT_SUCCESS', // Form submission succeeded
  FORM_SUBMIT: 'FORM_SUBMIT', // Form submission begun
  FORM_VIEWED: 'FORM_VIEWED', // Form within viewport
  MARKDOWN_BUTTON_CLICKED: 'MARKDOWN_BUTTON_CLICKED',
  VIEWED_EXPERIMENT: 'VIEWED_EXPERIMENT',
  VIEWED_PAGE: 'VIEWED_PAGE',
  VIEWED: 'VIEWED',
};

// `destination` on FORM_SUBMIT_* payloads. A Marketo form can send the same
// lead to both systems, so the event name alone does not identify the target.
export const FormDestinations = {
  CONVERSION: 'CONVERSION',
  MARKETO: 'MARKETO',
};
